<template>
  <label v-if="showLabel"><span class="input-label">{{ label }}</span>
    <input
        v-bind="$attrs"
        :type="inputType"
        :value="modelValue"
        @input="update"
        :class="!isValid ? 'input-invalid' : ''"
        :checked="checkboxValue"
    >
  </label>
  <input
      v-else
      v-bind="$attrs"
      :type="inputType"
      :value="modelValue"
      @input="update"
      :class="!isValid ? 'input-invalid' : ''"
      :checked="checkboxValue"
  >
</template>

<script>
import {validateProp} from 'utils/utils';

const TYPES = {
  TEXT: "text",
  PASSWORD: "password",
  EMAIL: "email",
  NUMBER: "number",
  URL: "url",
  TEL: "tel",
  SEARCH: "search",
  COLOR: "color",
  DATE: "DATE",
  CHECKBOX: "CHECKBOX"
};

const includes = types => type => types.includes(type);

export default {
  inheritAttrs: false,
  data() {
    return {
      isValid: true
    }
  },
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String,
      default: ""
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    attrs: {
      type: [],
      default: void 0
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: ""
    },
    type: {
      type: String,
      default: TYPES.TEXT,
      validator: value => validateProp(TYPES, value)
    },
    name: {
      type: String
    }
  },
  computed: {
    checkboxValue() {
      if (this.type === TYPES.CHECKBOX) {
        return this.value;
      }
      return false;
    },
    inputType() {
      if (this.type === TYPES.DATE) {
        return TYPES.TEXT.toLowerCase()
      } else {
        return this.type.toLowerCase()
      }
    }
  },
  methods: {
    validateInput(value) {
      var dic = window.netset.dic.global;
      if (this.type === TYPES.DATE) {
        return new RegExp(dic.dateRegExp).test(value)
      } else {
        return this.isValid;
      }
    },
    update(event) {
      this.isValid = this.validateInput(event.target.value);
      if (this.type === TYPES.CHECKBOX) {
        this.$emit('update:modelValue', event.target.checked);
      } else {
        this.$emit('update:modelValue', event.target.value);
      }
    }
  }
};
</script>

